import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import * as Notify from "@repoflow/form-schema/notify";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import { CancellableContent } from "@repoflow/components/content-cancel";
import * as widgets from "widgets/register";
import * as QueriesQL from "queries/site-domain";

export const Sidebar = () => null;

export const Indice = () => <BreadcrumbItem>Attach</BreadcrumbItem>;

export const Content = ({
  history,
  match: {
    params: { siteId },
  },
}) => {
  const { base } = useSectionContext();
  const initial = { host: "" };

  return (
    <Mutation
      initial={initial}
      target={{ $ref: "/Public/SiteDomain/Create" }}
      mutation={QueriesQL.create}
      update={QueriesQL.update()}
      onMutate={({ handler, state: { values: input } }) => {
        handler({ variables: { siteId, input } });
      }}
      onCompleted={() => {
        history.replace(base);
      }}
      onError={(error) => {
        // `siteDomain.create.exists` is the one a person will actually hit, and
        // it does not say which organization holds the name — deliberately, so
        // that asking is not a way to map hostnames to tenants.
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

const MutationHandler = ({ target, state, schema, mutate }) => {
  const { values, setValues } = state;

  const formProps = {
    schema,
    target,
    widgets,
    onSubmit: () => {
      mutate();
    },
    onChange: (values) => {
      setValues(values);
    },
    config: {
      "/Public/SiteDomain/Create": {
        fields: ["host"],
      },
    },
    values,
  };

  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            <p className="text-muted">
              The hostname visitors will type. Attaching it does not serve
              anything yet — publish the TXT record the next screen shows, then
              press Verify.
            </p>
            <Form {...formProps}>
              <Button type="submit">Attach</Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </CancellableContent>
  );
};
